import { render, staticRenderFns } from "./tbmDetail.vue?vue&type=template&id=611398d0"
import script from "./tbmDetail.vue?vue&type=script&lang=js"
export * from "./tbmDetail.vue?vue&type=script&lang=js"
import style0 from "./tbmDetail.vue?vue&type=style&index=0&id=611398d0&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('611398d0')) {
      api.createRecord('611398d0', component.options)
    } else {
      api.reload('611398d0', component.options)
    }
    module.hot.accept("./tbmDetail.vue?vue&type=template&id=611398d0", function () {
      api.rerender('611398d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmDetail.vue"
export default component.exports